import * as React from "react";
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCheck } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import ModalMUI from '@material-ui/core/Modal';
import ReactTableBase from '../../../../shared/components/table/ReactTableBase';
import ReactTableCustomizer from '../../../../shared/components/table/components/ReactTableCustomizer';
import ListRequirements from './ListRequirements';
import ListRequirementsActions from "./ListRequirementsActions";
import ModalRequirementsStudio from "./ModalRequirementsStudio";
import Tooltip from '@material-ui/core/Tooltip';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';

const RequirementsStudio = ({ location }) => {
    const history = useHistory();
    const [requirements, setRequirements] = React.useState([]);

    const [isLoading, setIsLoading] = React.useState(false);

    const [openModal, setOpenModal] = React.useState(false);
    let feasibility = location.state;

    const regresar = () => {
        let _url = "/clinical-studio/dashboard";
        history.push({
            pathname: process.env.PUBLIC_URL + _url,
            state: feasibility
        });
    }

    const openModalAction = (val) => {
        setOpenModal(val);
    }

    React.useEffect(() => {
        consultRequeriments();

    }, []);

    const consultRequeriments = async () => {
        setIsLoading(true);
        let dataReq = new FormData();
        dataReq.append("id_patrocinador", feasibility.id_tercero);
        dataReq.append("acronimo", feasibility.acronimo);

        fetch(`${process.env.REACT_APP_PUBLIC_URL}requerimientos/consultar`, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: dataReq
        }).then(response => response.json()).then(data => {
            let reqs = [];
            for (let i = 0; i < data.contenido.length; i++) {
                data.contenido[i].feasibility = location.state;
                reqs.push(data.contenido[i]);
            }
            setRequirements(reqs);
            setIsLoading(false);
        }).catch(error => {
            console.log(error)
            setIsLoading(false);
        });
    }

    const ListRequests = () => {
        return (
            <ListRequirements
                consultRequeriments={consultRequeriments}
                reactTableData={requirements}
                ReactTableActions={ListRequirementsActions} />);
    }

    return (<Container>
        <Row>
            <Col md={12}>
                <h3 className="page-title center-title">Lista de Requerimientos</h3>
                <h3 className="page-title center-title subhead">{feasibility.nombre_tercero} ({feasibility.acronimo})</h3>

                <Col md={2}>
                    <div className='top_info_buttons_hc'>
                        <div>
                            <Tooltip
                                title="Regresar al Dashboard"
                            >
                                <IconButton
                                    aria-label="upload picture"
                                    component="span"
                                    className='tooltip-top'
                                    onClick={() => {
                                        regresar();
                                    }}
                                >
                                    <ArrowBackIcon style={{ color: '#153365' }} />
                                </IconButton>
                            </Tooltip>
                            <span style={{ marginLeft: '0.25em' }}>Regresar al Dashboard</span>
                        </div>
                    </div>
                </Col>

            </Col>
        </Row>

        <Card className="card--flex">
            <CardBody className="width_static">
                <Container>
                    <div className="text-center">
                        <Button className="btn btn-sm btn-primary text-white" onClick={() => openModalAction(true)}>
                            Agregar
                        </Button>
                        <ModalRequirementsStudio
                            opened={openModal}
                            closeModal={openModalAction}
                            id_estudio={feasibility.id_estudio}
                            id_tercero={feasibility.id_tercero}
                            feasibility={feasibility}
                        />
                    </div>
                    <ListRequests />
                </Container>
            </CardBody>
        </Card>

        <ModalMUI
            open={isLoading}
            onClose={() => {
                setIsLoading(false);
            }}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            style={{ zIndex: 1000 }}
        >
            <div className="paperAppointment-flex" style={{ borderColor: 'white', boxShadow: 'white', height: '300x', width: '30%', margin: 10 }}>
                <div className="text-center">
                    <br /><br /><br />
                    <div class="load__icon-wrap">
                        <svg class="load__icon">
                            <path fill="#4ce1b6" d="M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z" />
                        </svg>
                    </div>
                    <br /><br /><br />
                </div>
            </div>
        </ModalMUI>


    </Container >);
}

export default reduxForm({
    form: 'form_requirements_show', // a unique identifier for this form
})(RequirementsStudio);